/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Export_NameInputs */

const en_manual_qc_export_name = /** @type {(inputs: Manual_Qc_Export_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

const fr_manual_qc_export_name = /** @type {(inputs: Manual_Qc_Export_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom`)
};

const de_manual_qc_export_name = /** @type {(inputs: Manual_Qc_Export_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

const it_manual_qc_export_name = /** @type {(inputs: Manual_Qc_Export_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome`)
};

const ru_manual_qc_export_name = /** @type {(inputs: Manual_Qc_Export_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Имя`)
};

const es_manual_qc_export_name = /** @type {(inputs: Manual_Qc_Export_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre`)
};

const zh_cn2_manual_qc_export_name = /** @type {(inputs: Manual_Qc_Export_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`姓名`)
};

const ja_manual_qc_export_name = /** @type {(inputs: Manual_Qc_Export_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前`)
};

const hi_manual_qc_export_name = /** @type {(inputs: Manual_Qc_Export_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नाम`)
};

const pt_pt2_manual_qc_export_name = /** @type {(inputs: Manual_Qc_Export_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome`)
};

/**
* | output |
* | --- |
* | "Name" |
*
* @param {Manual_Qc_Export_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_export_name = /** @type {((inputs?: Manual_Qc_Export_NameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Export_NameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_export_name(inputs)
	if (locale === "de") return de_manual_qc_export_name(inputs)
	if (locale === "it") return it_manual_qc_export_name(inputs)
	if (locale === "ru") return ru_manual_qc_export_name(inputs)
	if (locale === "es") return es_manual_qc_export_name(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_export_name(inputs)
	if (locale === "ja") return ja_manual_qc_export_name(inputs)
	if (locale === "hi") return hi_manual_qc_export_name(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_export_name(inputs)
	return en_manual_qc_export_name(inputs)
});